/**
 * This component wraps React-Router's Redirect by providing name-based routing.
 * (Helps to narrow down the scope of possible format changes to routes.)
 */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { pathByRouteName } from '../../util/routes';
import { LanguageContext } from '../../context/LanguageContext';

const NamedRedirect = props => {
  const routeConfiguration = useRouteConfiguration();
  const { name, search, state, push } = props;
  const { locale } = useContext(LanguageContext);

  // Get provided params or default to empty
  const providedParams = props.params || {};

  // Inject lang unless already passed or locale is 'en'
  const params = {
    ...providedParams,
    ...(providedParams.lang ? {} : locale !== 'en' ? { lang: locale } : {}),
  };

  const pathname = pathByRouteName(name, routeConfiguration, params);

  return <Redirect to={{ pathname, search, state }} push={push} />;
};

const { bool, object, string } = PropTypes;

NamedRedirect.defaultProps = {
  search: '',
  state: {},
  push: false,
  params: {},
};

NamedRedirect.propTypes = {
  name: string.isRequired,
  search: string,
  state: object,
  push: bool,
  params: object,
};

export default NamedRedirect;
